"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, hasClass, addClass, removeClass, closest, find, findAllIn, findIn} from "@elements/dom-utils";

// Variables

export function init() {
    onFind('.js-fancy-select', function (dropdown) {
        let input = findIn('.js-fancy-select__input', dropdown);
        let inputAddition = findIn('.js-fancy-select__input-addition', dropdown);
        let listOfOptions = findAllIn('.js-fancy-select__option', dropdown);
        let body = document.body;

        // Functions

        // basic toggle (open/close) function
        // "classList.toggle(className)" toggles 'opened' class
        const toggleDropdown = (event) => {
            event.stopPropagation();
            dropdown.classList.toggle('opened');
        };

        // option selection from dropdown list
        // used "event.currentTarget" to specify the selected option
        // after option is chosen, its "textContent" value being copied to input's value
        const selectOption = (event) => {
            let title = findIn('.js-fancy-select__option-title', event.currentTarget);
            let subtitle = findIn('.js-fancy-select__option-subtitle', event.currentTarget);

            input.value = title.innerText;
            inputAddition.innerHTML = subtitle.textContent;
        };

        // we want the dropdown list to close when clicked outside of it
        // ex: no option was selected
        // we do a simple check below
        // if dropdown list is in opened state
        // then remove the ".opened" class
        const closeDropdownFromOutside = () => {
            if (dropdown.classList.contains('opened')) {
                dropdown.classList.remove('opened');
            }
        };

        // Event Listeners
        // if we click anywhere on "body" and dropdown list opened
        // the dropdown will be closed
        body.addEventListener('click', closeDropdownFromOutside);

        // options selection
        listOfOptions.forEach((option) => {
            option.addEventListener('click', selectOption);
        });

        // dropdown toggle
        dropdown.addEventListener('click', toggleDropdown);
    });
}

